"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Menu = void 0;
var _reactSelect = require("react-select");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Menu = (0, _styledComponents.default)(_reactSelect.components.Menu)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  z-index: 10 !important;\n  background: ", ";\n  margin-top: 5px !important;\n  margin-bottom: 0 !important;\n  box-shadow: none !important;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.secondary;
});
exports.Menu = Menu;